// extracted by mini-css-extract-plugin
export var body = "index-module--body--vvqgI";
export var single_member = "index-module--single_member--++9iN";
export var team_container = "index-module--team_container--ilDYG";
export var team_grid = "index-module--team_grid--0kRa0";
export var title = "index-module--title--RchvF";